import React from 'react';
import { TouchableOpacity, StatusBar, ScrollView, StyleSheet, Text, View, Image, Modal } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { CommonActions } from '@react-navigation/native';

export default function Assignment({ navigation, route }) {
    const [modalVisible, setModalVisible] = React.useState(false);

    const styles = StyleSheet.create({
        container: {
            flex: 1,
            backgroundColor: 'white'
        },
        image: {
            height: 300,
            width: '100%',
            resizeMode: 'cover',
            backgroundColor: '#ddd'
        },
        backButton: {
            position: 'absolute',
            top: 40,
            left: 20,
            backgroundColor: '#fff',
            width: 60,
            height: 60,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 30
        },
        logo: {
            height: 100,
            width: 100,
            resizeMode: 'cover',
            position: 'absolute',
            top: -50,
            left: 10,
            borderRadius: 80,
            borderColor: '#ddd',
            borderWidth: 1
        },
        section: {
            padding: 20,
            borderTopWidth: 1,
            borderColor: '#ddd'
        }
    });

    return (
        <ScrollView style={styles.container}>
            <Modal
                presentationStyle="formSheet"
                visible={modalVisible}
                animationType='slide'
                >
                <ScrollView style={{ padding: 40 }}>
                    <TouchableOpacity onPress={() => setModalVisible(false)} style={styles.button}>
                        <Text>Close</Text>
                    </TouchableOpacity>

                    <View style={{ height: 20 }}></View>

                    <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Info</Text>

                    <View style={{ height: 20 }}></View>

                    <Text>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis diam. Pellentesque ut neque. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. In ac felis quis tortor malesuada pretium. Pellentesque auctor neque nec urna. Proin sapien ipsum, porta a, auctor quis, euismod ut, mi. Aenean viverra rhoncus pede. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut non enim eleifend felis pretium feugiat. Vivamus quis mi. Phasellus a est. Phasellus magna. In hac habitasse platea dictumst. Curabitur at lacus ac velit ornare lobortis. Curabitur a felis in nunc fringilla tristique.</Text>
                </ScrollView>
            </Modal>

            <StatusBar barStyle="light-content" backgroundColor="#000" />
            <Image
                    style={ styles.image }
                    source={require('../assets/pizza.jpeg')}
                />
            <TouchableOpacity style={ styles.backButton } onPress={() => navigation.dispatch(CommonActions.goBack())}>
                <View>
                    <Ionicons name={ route.params?.icon ?? 'chevron-back' } size={30} color='black' />
                </View>
            </TouchableOpacity>

            <View style={{ paddingLeft: 120, paddingRight: 20, paddingVertical: 20 }}>
                <Image
                    style={styles.logo}
                    source={require('../assets/dominos.jpg')}
                />
                <Text style={{ fontSize: 30, fontWeight: 'bold', marginBottom: 5 }}>Buy some pizza</Text>
                <Text>Central Station, Arnhem</Text>
            </View>

            <TouchableOpacity onPress={ () => setModalVisible(true) }>
                <View style={ styles.section }>
                    <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Assignment Info</Text>
                </View>
            </TouchableOpacity>

            <TouchableOpacity onPress={ () => setModalVisible(true) }>
                <View style={ styles.section }>
                    <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Location Info</Text>
                </View>
            </TouchableOpacity>

            <TouchableOpacity onPress={ () => setModalVisible(true) }>
                <View style={ styles.section }>
                    <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Badges</Text>
                </View>
            </TouchableOpacity>

            <TouchableOpacity onPress={ () => setModalVisible(true) }>
                <View style={ styles.section }>
                    <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Apply</Text>
                </View>
            </TouchableOpacity>
        </ScrollView>
    );
}
